<mat-card class="slidecontent">
    <div class="headcontent">
      <div class="pophead">
        <h3>Procedure Detail</h3>
        <button mat-icon-button (click)="closeCase(false)">
          <mat-icon class="close" >close</mat-icon>
        </button>
      </div>
  
    </div>
    <div class="dialog_content">
        <mat-form-field appearance="">
            <mat-label>Procedure Name </mat-label>
            <input matInput value="Debridement of wound, burn, or infection">
          </mat-form-field>


        <mat-form-field appearance="">
            <mat-label>Surgeon</mat-label>
            <mat-select>
              <mat-option value="1">M.Mcalpin</mat-option>
              <mat-option value="2">A.Jethro</mat-option>
            </mat-select>
         </mat-form-field>

         <mat-form-field appearance="">
            <mat-label>Patient</mat-label>
            <mat-select>
              <mat-option value="1">D.Williams</mat-option>
              <mat-option value="2">E.Walsokvi</mat-option>
            </mat-select>
         </mat-form-field>         

         <mat-form-field appearance="">
          <mat-label>Add Case</mat-label>
          <mat-select selected="1">
            <mat-option value="1">Wound surgery along with infection</mat-option>
          </mat-select>
       </mat-form-field>
       
      <mat-form-field class="">
        <mat-label>Tags</mat-label>
        <mat-chip-list #chipList aria-label="Fruit selection">
          <mat-chip
            *ngFor="let fruit of fruits"
            [selectable]="selectable"
            [removable]="removable"
            (removed)="remove(fruit)">
            {{fruit}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip>
          <input
            placeholder="Type & Select Procedure..."
            #fruitInput
            [formControl]="fruitCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
            {{fruit}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="">
        <mat-label>Equipment</mat-label>
        <mat-chip-list #chipList aria-label="Fruit selection">
          <mat-chip
            *ngFor="let fruit of fruits"
            [selectable]="selectable"
            [removable]="removable"
            (removed)="remove(fruit)">
            {{fruit}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip>
          <input
            placeholder="Type & Select Procedure..."
            #fruitInput
            [formControl]="fruitCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
            {{fruit}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    
      <mat-form-field appearance="">
        <mat-label>Facility</mat-label>
        <mat-select>
          <mat-option value="1">Home Care</mat-option>
          <mat-option value="2">Green Care</mat-option>
        </mat-select>
     </mat-form-field>

     <mat-form-field appearance="">
      <mat-label>Room</mat-label>
      <mat-select>
        <mat-option value="1">F1-1</mat-option>
        <mat-option value="2">F2-1</mat-option>
      </mat-select>
   </mat-form-field>


          
   <mat-form-field appearance="">
    <mat-label>Date</mat-label>
    <input matInput [matDatepicker]="picker">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="">
    <mat-label>Time</mat-label>
    <input matInput>
  </mat-form-field>
  <mat-form-field appearance="">
    <mat-label>Duration</mat-label>
    <input matInput>
  </mat-form-field>

  <mat-form-field appearance="">
    <mat-label>Description</mat-label>
    <textarea matInput></textarea>
  </mat-form-field>

    </div>
  
  
    <div class="actionBtn">
      <button mat-flat-button class="calltoaction" type="submit"  color="basic"> Close </button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary">Reschedule</button>
    </div>
  </mat-card>
  

  <div class="overlay" (click)="closeCase(false)" ></div>
  
